export default "__VITE_ASSET__B02$vXdH__"